import { areObjectsDeeplyEqual } from '@vfde-sails/utils';
import { State } from './';

/**
 * Helper function to help determine which part of the UI
 * needs to be updated based on state changes
 * @param {State} newState - new state
 * @param {State} oldState - old state
 * @returns {Object} - object containing booleans
 */
export const getUpdateFlags = (state: State, oldState: State) => {
    const { suggestions, primary, secondary, isLeadManagement, selectedAddress } = state;

    return {
        suggestions: !areObjectsDeeplyEqual(suggestions, oldState.suggestions),
        primary: !areObjectsDeeplyEqual(primary, oldState.primary),
        secondary: !areObjectsDeeplyEqual(secondary, oldState.secondary),
        selectedAddress: !areObjectsDeeplyEqual(selectedAddress, oldState.selectedAddress),
        isLeadManagement: isLeadManagement !== oldState.isLeadManagement,
    };
};
